/* global $:false */

export default class FilterList {
  // Expects the following DOM structure:
  //
  // input.js-filter-input
  //
  // .js-filter
  //   .js-filter__list
  //
  //     div Item 1
  //       div Planet name:
  //       div.js-filter__value Saturn
  //
  //     div Item 2
  //       div Planet name:
  //       div.js-filter__value Mars
  //
  // .js-filter
  //   # Here you can have another list, it uses the same global search input.
  //
  static init () {
    Array.from($('.js-filter')).map((el) =>
      new FilterList(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setup()
  }

  findElements () {
    this.globalSearchInput = $('.js-filter-input')
    this.list = this.el.find('.js-filter__list')
  }

  setup () {
    const options = {
      listClass: this.list.selector.slice(1),
      searchClass: this.globalSearchInput.selector.slice(1),
      valueNames: ['js-filter__value', 'js-filter__value1', 'js-filter__value2', 'js-filter__value3', 'js-filter__value4', 'js-filter__value5']
    }

    const instance = new window.List(this.el[0], options)

    // Current use-case: One search input, multiple lists.
    this.globalSearchInput.keyup(() => {
      instance.search(this.globalSearchInput.val())
    })
  }
}
